import { render, staticRenderFns } from "./ArticleSellingpriceCompositionCard.vue?vue&type=template&id=621fd2a3"
import script from "./ArticleSellingpriceCompositionCard.vue?vue&type=script&lang=ts"
export * from "./ArticleSellingpriceCompositionCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSellingpriceCompositionCard.vue?vue&type=style&index=0&id=621fd2a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports